import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../../slidebar/components/DarkMode";
import * as actions from "../../redux/PromotionAction";
import { PromotionForm } from "./PromotionForm";

export const PromotionDialog = ({
  setShow,
  show,
  promotionId,
  setSwalProps,
  setPromotionId,
  isEditable,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const formikRef = useRef();
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => {
    setShow(false);
    setPromotionId(undefined);
  };

  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  useEffect(() => {
    if (!promotionId) {
      dispatch(actions.fetchPromotionUI());
    } else {
      dispatch(actions.fetchPromotionDetail({ promotionid: promotionId }));
    }

    return () => dispatch(actions.clearPromotionUI());
  }, [promotionId]);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const saveValues = (queryParams) => {
    const manageActions = promotionId
      ? actions.updatePromotion
      : actions.createPromotion;

    dispatch(manageActions({ ...queryParams, promotionid: promotionId })).then(
      (resp) => {
        resp = resp.data;

        if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
          setSwalProps({
            show: true,
            icon: "success",
            title: intl.formatMessage({ id: "success" }),
            text: intl.formatMessage({
              id: promotionId ? "updateSuccessfully" : "createSuccessfully",
            }),
            onConfirm: () => {
              dispatch(actions.fetchPromotionList());
              handleClose();
            },
            onClose: () => {
              handleClose();
            },
          });
        } else {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      }
    );
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: promotionId ? "editPromotion" : "addPromotion",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {promotionState.promotionUI ? (
            promotionState.promotionUI.code === "0" ? (
              <PromotionForm
                formikRef={formikRef}
                promotionId={promotionId}
                saveValues={saveValues}
                isEditable={isEditable}
              />
            ) : (
              promotionState.promotionUI.message
            )
          ) : (
            <div className="d-flex align-items-center justify-content-center">
              <div className="spinner-border text-warning" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
          {promotionState.promotionUI?.code === "0" && isEditable && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => formikRef.current.submitForm()}
            >
              {intl.formatMessage({ id: "saveChanges" })}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
